import React from 'react'

function index() {
  return (
    <div>index</div>
  )
}

export default index